// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1BVzN","colCheckbox":"styles_colCheckbox__1P0rB"};